import NetworkProvider from '../Provider';

const url = '/api/v1/verify/facebook';

const verifyWithFacebook = async (accessToken) => {
  const payload = {
    accessToken,
  };
  return NetworkProvider().post(url, payload);
};

export default verifyWithFacebook;